import { cn } from '@/lib/utils';
import { senderSurfaceClass } from '@/pages/sender/components/sender-surface';
import { UploadIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface SenderUploadZoneProps {
	label: string;
	hint?: string;
	disabled?: boolean;
	busy?: boolean;
	onPick: () => void;
	children?: ReactNode;
}

export default function SenderUploadZone({
	label,
	hint,
	disabled,
	busy,
	onPick,
	children,
}: SenderUploadZoneProps) {
	return (
		<div className='flex flex-col gap-2'>
			<button
				type='button'
				disabled={disabled || busy}
				onClick={onPick}
				className={cn(
					senderSurfaceClass,
					'flex min-h-[88px] w-full flex-col items-center justify-center gap-2 px-4 py-6 text-center transition-colors',
					!disabled && !busy && 'active:bg-accent/20',
					disabled && 'opacity-50',
				)}
			>
				<UploadIcon size={22} className='text-muted-foreground' />
				<span className='text-[15px] font-medium'>{label}</span>
				{hint ? <span className='text-[13px] text-muted-foreground'>{hint}</span> : null}
			</button>
			{children}
		</div>
	);
}
